import React from "react";
import { Control, FieldValues, FormState, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { FormContainer } from "../../../../../../../../../shared/form/form.styles";
import OrganizationForm from "./OrganizationInfoForm";
import AddressForm from "./AddressForm";

const LegalPerson: React.FC<{
  register: UseFormRegister<FieldValues>;
  formState: FormState<FieldValues>;
  control: Control;
  setValue: UseFormSetValue<FieldValues>;
}> = (props) => {
  return (
    <FormContainer leftContent noScrollContent>
      <OrganizationForm {...props} />
      <AddressForm {...props} />
    </FormContainer>
  );
};

export default LegalPerson;
